import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { KeyDetailsStrip } from '../components/KeyDetailsStrip';
import { KeyHighlights } from '../components/KeyHighlights';
import { WhyCremorne } from '../components/WhyCremorne';
import { GallerySection } from '../components/GallerySection';
import { AgentSection } from '../components/AgentSection';
import { Footer } from '../components/Footer';
export function PropertyPage() {
  return <div className="min-h-screen bg-brand-black selection:bg-brand-gold selection:text-brand-black" data-id="element-88">
      <Navbar data-id="element-89" />
      <main data-id="element-90">
        <HeroSection data-id="element-91" />
        <KeyDetailsStrip data-id="element-92" />
        <KeyHighlights data-id="element-93" />
        <WhyCremorne data-id="element-94" />
        <GallerySection data-id="element-95" />
        <AgentSection data-id="element-96" />
      </main>
      <Footer data-id="element-97" />
    </div>;
}